!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t(require("react"), require("prop-types"), require("@leafygreen-ui/emotion")) : "function" == typeof define && define.amd ? define(["react", "prop-types", "@leafygreen-ui/emotion"], t) : ((e = "undefined" != typeof globalThis ? globalThis : e || self).Copy = e.Copy || {}, e.Copy.js = t(e.React, e.PropTypes, e["@leafygreen-ui/emotion"]));
}(this, function (e, t, r) {
  "use strict";

  function n(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }
  function l(e) {
    if (e && "object" == typeof e && "default" in e) return e;
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function (r) {
      if ("default" !== r) {
        var n = Object.getOwnPropertyDescriptor(e, r);
        Object.defineProperty(t, r, n.get ? n : {
          enumerable: !0,
          get: function () {
            return e[r];
          }
        });
      }
    }), t.default = e, Object.freeze(t);
  }
  var i = l(e),
    a = n(t);
  function o(e, t, r) {
    return (t = function (e) {
      var t = function (e, t) {
        if ("object" != typeof e || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === t ? String : Number)(e);
      }(e, "string");
      return "symbol" == typeof t ? t : String(t);
    }(t)) in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }
  function u() {
    return u = Object.assign ? Object.assign.bind() : function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, u.apply(this, arguments);
  }
  function f(e, t) {
    if (null == e) return {};
    var r,
      n,
      l = function (e, t) {
        if (null == e) return {};
        var r,
          n,
          l = {},
          i = Object.keys(e);
        for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        return l;
      }(e, t);
    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);
      for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
    }
    return l;
  }
  function c(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(t)
      }
    }));
  }
  var s,
    p,
    b = {
      small: 14,
      default: 16,
      large: 20,
      xlarge: 24
    };
  var y = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"],
    d = function (e) {
      var t,
        n = e.className,
        l = e.size,
        a = void 0 === l ? 16 : l,
        d = e.title,
        m = e["aria-label"],
        g = e["aria-labelledby"],
        v = e.fill,
        C = e.role,
        O = void 0 === C ? "img" : C,
        j = f(e, y),
        h = r.css(s || (s = c(["\n        color: ", ";\n      "])), v),
        H = r.css(p || (p = c(["\n        flex-shrink: 0;\n      "]))),
        V = function (e, t, r) {
          var n,
            l,
            i = r["aria-label"],
            a = r["aria-labelledby"],
            u = r.title;
          switch (e) {
            case "img":
              return i || a || u ? (o(n = {}, "aria-labelledby", a), o(n, "aria-label", i), o(n, "title", u), n) : {
                "aria-label": (l = t, "".concat(l.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon"))
              };
            case "presentation":
              return {
                "aria-hidden": !0,
                alt: ""
              };
          }
        }(O, "Copy", (o(t = {
          title: d
        }, "aria-label", m), o(t, "aria-labelledby", g), t));
      return i.createElement("svg", u({
        className: r.cx(o({}, h, null != v), H, n),
        height: "number" == typeof a ? a : b[a],
        width: "number" == typeof a ? a : b[a],
        role: O
      }, V, j, {
        viewBox: "0 0 16 16"
      }), i.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 5.71428V10.2857C1 11.2325 1.76751 12 2.71429 12H5.75V7.10957C5.75 6.54414 5.97724 6.00244 6.38065 5.60623L8.67403 3.35381C8.77447 3.25516 8.88376 3.16757 9 3.09182V2.71429C9 1.76751 8.23249 1 7.28571 1H5.8V4.42857C5.8 5.13865 5.22437 5.71428 4.51429 5.71428H1ZM9 4.78571L7.25654 6.49804C7.24689 6.50752 7.23749 6.5172 7.22834 6.52708C7.22208 6.53383 7.21594 6.54068 7.20991 6.54762C7.07504 6.70295 7 6.90234 7 7.10957V7.79762H9H10.0095C10.4829 7.79762 10.8667 7.41386 10.8667 6.94047V4H10.1505C9.92587 4 9.7102 4.0882 9.54992 4.24562L9 4.78571ZM4.86667 1H4.15053C3.92587 1 3.7102 1.0882 3.54992 1.24562L1.25654 3.49804C1.09244 3.65921 1 3.87957 1 4.10957V4.79762H4.00952C4.48291 4.79762 4.86667 4.41386 4.86667 3.94047V1ZM7 12V8.71428H9H10.5143C11.2244 8.71428 11.8 8.13865 11.8 7.42857V4H13.2857C14.2325 4 15 4.76751 15 5.71429V13.2857C15 14.2325 14.2325 15 13.2857 15H8.71429C7.76751 15 7 14.2325 7 13.2857V12Z",
        fill: "currentColor"
      }));
    };
  return d.displayName = "Copy", d.isGlyph = !0, d.propTypes = {
    fill: a.default.string,
    size: a.default.oneOfType([a.default.number, a.default.string]),
    className: a.default.string
  }, d;
});